import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import Form from "@/components/organization/OrganizationForm/Form";
import { useCreateOrganizationMutation } from "@/libs/generated/hooks";
import { queryClient } from "@/libs/queryClient";
import type { OrganizationFormSchemaType } from "@/schemas/organization-form";
import { RoutePaths } from "@/utils/constants/routes";

function NewOrganization() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const createOrganization = useCreateOrganizationMutation({
    onSuccess: async (data) => {
      toast.success(t("network.organization.created", { name: data.createOrganization.name }), {
        position: "bottom-right",
      });

      // Actively refetch all findAllOrganizations queries to ensure new org appears
      await queryClient.refetchQueries({
        queryKey: ["findAllOrganizations"],
      });
      navigate(RoutePaths.adminOrganizationsTable);
    },
    onError: (error) => {
      toast.error(error.message || t("network.errors.unknown"), {
        position: "bottom-right",
      });
    },
  });

  const onSubmit = async (formData: OrganizationFormSchemaType) => {
    await createOrganization.mutateAsync({
      CreateOrganizationInput: {
        ...formData,
      },
    });
  };

  return (
    <Container maxWidth="lg">
      <Grid container sx={{ position: "relative", top: "80px", paddingBottom: 10 }}>
        <Grid size={{ xs: 12 }}>
          <Form onSubmit={onSubmit} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default NewOrganization;
